export default __webpack_public_path__ + "static/media/planet6.9267f9f4.png";